/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: RoleService
  Description: This class is responsible for incidents stuff.
*/
class RoleService {
  /* 
    Obtain all roles from the api.
  */
  async getAllRoles() {
    const response = await axios.get("api/roles");

    return response;
  }

  /* 
    Assign new role to user from the api.
  */
  assignRole(data) {
    return axios.post("api/administrator/roles/assign", data, {
      headers: {
        Authorization:
          "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
      },
    }).then((response) => {
      return response.data;
    });
  }

  /* 
    Show all user roles.
  */
  showRoles(roles) {
    var rolesData = "";

    try {
      for (var i = 0; i < roles.length; i++) {
        rolesData += roles[i].name + ", ";
      }

      return rolesData.slice(0, -2);
    } finally {
      rolesData = null;
    }
  }
}

export default new RoleService();
